/* eslint-disable max-len */
import React from 'react';
import { Modal, TransitionablePortal } from 'semantic-ui-react';
import QRCode from 'qrcode.react';
import { func, shape } from 'prop-types';

import css from './DoctorQRCode.less';

const DoctorQRCode = ({ onClose, userDetails }) => (
  <div className={css.container}>
    <TransitionablePortal open transition={{ animation: 'fly up', duration: 500 }}>
      <Modal onClose={onClose} open closeIcon size="small" className={css.customModal}>
        <Modal.Header className={css.modalHeader}>QR Code</Modal.Header>
        <Modal.Content className={css.modalContent}>
          <div
            className={css.avatar}
            style={{ backgroundImage: `url(${userDetails?.avatar?.originalPath})` }}
          />
          <h4 className={css.name}>{userDetails?.name}</h4>
          <h5 className={css.desc}>{userDetails?.title?.title}</h5>
          <QRCode size={160} value={`https://manadr.com/doctors/${userDetails?.slug}`} />
        </Modal.Content>
      </Modal>
    </TransitionablePortal>
  </div>
);

export default DoctorQRCode;

DoctorQRCode.defaultProps = {};
DoctorQRCode.propTypes = {
  onClose: func.isRequired,
  userDetails: shape({}).isRequired,
};
